module.exports = __webpack_public_path__ + "static/project-f49a8c8cd420ada177d590d7c487e85c.svg";